import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Drawer from '@mui/material/Drawer';

import { getDrawer, closeDrawer } from '../../reducers/infodrawer';

const InfoDrawer = () => {
  const { open, type, content } = useSelector(getDrawer);
  const dispatch = useDispatch();

  if (!open) return '';

  let Content;

  switch (type) {
    case 'CUSTOM_DRAWER_CONTENT':
      // Content = SampleCustomInfoDrawer;
      break;
    default:
      Content = <div>Some content!</div>;
      break;
  }

  return (
    <Drawer anchor="bottom" open={open} onClose={() => dispatch(closeDrawer())}>
      <Content content={content} drawer />
    </Drawer>
  );
};

export default InfoDrawer;
